/**
 * Who may reach BFC's internal operational tooling.
 *
 * This is the seam, not the answer. The real check belongs on the authorization
 * policy - `/authz/get-policy` already returns roles and permissions, and
 * `AaaApiClient.getPolicy()` already fetches it - but no role today means "BFC
 * staff", and inventing one here would put a product decision in a helper
 * function. So this reads a build-time flag, and every route under `_internal`
 * asks this one question.
 *
 * It defaults to **enabled**. These are live tools that BFC operators use daily;
 * shipping a default that hides them would be removing a working feature to
 * make a point about layering. Set `VITE_INTERNAL_TOOLS=off` to see what a
 * customer sees.
 *
 * Replacing the flag with a policy check should mean changing this function and
 * nothing else.
 */
export function internalToolsEnabled(): boolean {
  return import.meta.env.VITE_INTERNAL_TOOLS !== "off";
}
